// extracted by mini-css-extract-plugin
export default {"colorPrimary":"#20a8d8"};